export default __webpack_public_path__ + "static/media/become_vendor.dfe93133.svg";